import { Box, Button, TextField, Typography, styled } from "@mui/material";

/*
 * Shared dark-theme primitives for the ForgottenPassword flow so all four
 * steps match the dark gym login. Visual only — no behaviour lives here.
 */

export const StepRoot = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const CloseRow = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  padding: "20px 24px 0",
  "& svg": {
    width: "16px",
    height: "16px",
  },
  "& svg path": {
    fill: "rgba(255,255,255,0.6)",
    stroke: "rgba(255,255,255,0.6)",
  },
});

export const CloseButton = styled(Box)({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "34px",
  height: "34px",
  borderRadius: "10px",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.08)",
  },
});

export const StepBody = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  padding: "8px 40px 40px",
  [theme.breakpoints.down("md")]: {
    padding: "8px 22px 32px",
    flex: 1,
  },
}));

export const StepTitle = styled(Typography)(({ theme }) => ({
  color: "#FFFFFF",
  fontWeight: 800,
  fontSize: "30px",
  lineHeight: "38px",
  letterSpacing: "-0.5px",
  textAlign: "center",
  marginBottom: "10px",
  [theme.breakpoints.down("md")]: {
    fontSize: "26px",
    lineHeight: "32px",
  },
}));

export const StepSubtitle = styled(Typography)(({ theme }) => ({
  color: "rgba(255,255,255,0.62)",
  fontWeight: 400,
  fontSize: "15px",
  lineHeight: "23px",
  textAlign: "center",
  maxWidth: "402px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "28px",
  [theme.breakpoints.down("md")]: {
    fontSize: "13.5px",
    lineHeight: "20px",
    marginBottom: "22px",
  },
}));

export const FieldLabel = styled(Typography)({
  fontSize: "13px",
  fontWeight: 600,
  color: "rgba(255,255,255,0.78)",
  marginBottom: "8px",
  letterSpacing: "0.2px",
});

export const FieldGroup = styled(Box)({
  width: "100%",
  maxWidth: "414px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "18px",
});

export const DarkTextField = styled(TextField)({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "rgba(255,255,255,0.04)",
    transition: "all 0.2s ease",
    "& fieldset": {
      borderColor: "rgba(255,255,255,0.12)",
      transition: "all 0.2s ease",
    },
    "&:hover fieldset": {
      borderColor: "rgba(1,187,167,0.55)",
    },
    "&.Mui-focused": {
      backgroundColor: "rgba(255,255,255,0.06)",
      boxShadow: "0 0 0 4px rgba(1,187,167,0.14)",
      "& fieldset": {
        borderColor: "#01BBA7",
        borderWidth: "1.5px",
      },
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px 16px",
    fontSize: "15px",
    color: "#FFFFFF",
    textAlign: "inherit",
    "&::placeholder": {
      color: "rgba(255,255,255,0.38)",
      opacity: 1,
    },
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#FFFFFF",
      WebkitBoxShadow: "0 0 0 1000px rgba(20,26,38,0.9) inset",
      caretColor: "#FFFFFF",
      transition: "background-color 9999s ease-in-out 0s",
    },
  },
});

export const PrimaryButton = styled(Button)({
  width: "100%",
  marginTop: "8px",
  padding: "15px 24px",
  borderRadius: "12px",
  fontSize: "16px",
  fontWeight: 700,
  letterSpacing: "0.3px",
  textTransform: "none",
  color: "#04231F",
  background: "linear-gradient(135deg, #3FD3C2 0%, #01BBA7 100%)",
  boxShadow: "0 8px 24px rgba(1,187,167,0.35)",
  transition: "all 0.2s ease",
  "&:hover": {
    background: "linear-gradient(135deg, #01BBA7 0%, #019385 100%)",
    boxShadow: "0 10px 30px rgba(1,187,167,0.45)",
    transform: "translateY(-1px)",
  },
  "&:active": {
    transform: "translateY(0)",
  },
  "&.Mui-disabled": {
    background: "rgba(255,255,255,0.08)",
    color: "rgba(255,255,255,0.32)",
    boxShadow: "none",
  },
});

export const LinkButton = styled(Button)({
  textTransform: "none",
  fontSize: "13.5px",
  fontWeight: 500,
  color: "rgba(255,255,255,0.7)",
  "&:hover": {
    backgroundColor: "rgba(1,187,167,0.1)",
    color: "#01BBA7",
  },
});

export const ButtonRow = styled(Box)({
  width: "100%",
  maxWidth: "414px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "8px",
});

// Single OTP digit box, dark-themed.
export const DigitField = styled(DarkTextField)({
  width: "56px",
  "& .MuiInputBase-input": {
    padding: "14px 0",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 700,
  },
});
